import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ListingPage.module.css';

const CaskTab = ({
  producerLabel,
  filledDateLabel,
  spiritTypeLabel,
  listingAgeLabel,
  mashbill,
  auctionFieldRows = [],
  intl,
}) => {
  return (
    <div className={css.tastingNotes}>
      <h2>
        <FormattedMessage
          id="ListingPage.keySpecifications.title"
          defaultMessage="Key Specifications"
        />
      </h2>

      <div className={css.featureSec}>
        <div className={css.feature}>
          <span>
            <FormattedMessage id="ListingPage.specs.distillery" defaultMessage="Distillery" />
          </span>
          <span>{producerLabel || '-'}</span>
        </div>

        <div className={css.feature}>
          <span>
            <FormattedMessage id="ListingPage.specs.filledDate" defaultMessage="Filled Date" />
          </span>
          <span>{filledDateLabel || '-'}</span>
        </div>

        {listingAgeLabel ? (
          <div className={css.feature}>
            <span>
              <FormattedMessage id="ListingPage.specs.age" defaultMessage="Age" />
            </span>
            <span>{listingAgeLabel}</span>
          </div>
        ) : null}

        {spiritTypeLabel ? (
          <div className={css.feature}>
            <span>
              <FormattedMessage id="ListingPage.specs.spiritType" defaultMessage="Spirit Type" />
            </span>
            <span>{spiritTypeLabel}</span>
          </div>
        ) : null}

        {mashbill ? (
          <div className={css.feature}>
            <span>
              <FormattedMessage id="ListingPage.specs.mashbill" defaultMessage="Mashbill" />
            </span>
            <span>{mashbill}</span>
          </div>
        ) : null}

        {auctionFieldRows.map(row => (
          <div className={css.feature} key={row.id}>
            <span>
              <FormattedMessage id={row.id} />
            </span>
            <span>{row.value || '-'}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaskTab;
